export enum ApiErrors {
  /**
   * Token 过期
   */
  TokenExpired = 262033,
  /**
   * RefreshToken 过期
   */
  RefreshTokenExpired = 263041
}
